<div #modal class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button id='offerExportModalDialogClose' type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title" id="myModalLabel">{{ data ? data.title : '' }}</h4>
      </div>
      <div class="modal-body">
        <div class="member-modal-cont">
          <div>Period:</div>
          <ch-daterangepicker (selected)="datepickerChanged($event)" pastSearch="true"
          id="offer-export-modal-period-picker"></ch-daterangepicker>
        </div>
      </div>
      <div class="modal-footer"><button id='offerExportModalDialogExport' type="button" class="btn btn-success default-btn" (click)="export()">Export</button></div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/offer-export-modal-dialog/offer-export-modal-dialog.component.html